
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M437.02 74.98C388.668 26.628 324.38 0 256 0S123.332 26.628 74.98 74.98C26.629 123.332 0 187.62 0 256s26.629 132.668 74.98 181.02C123.332 485.372 187.62 512 256 512s132.668-26.628 181.02-74.98C485.371 388.668 512 324.38 512 256s-26.629-132.668-74.98-181.02zM256 482C131.383 482 30 380.617 30 256S131.383 30 256 30s226 101.383 226 226-101.383 226-226 226z"}}),_c('path',{attrs:{"d":"M272.067 241h-32.134c-18.307 0-33.2-14.893-33.2-33.199 0-18.307 14.894-33.2 33.2-33.2H304.2c8.284 0 15-6.716 15-15s-6.716-15-15-15H271v-33.2c0-8.284-6.716-15-15-15s-15 6.716-15 15v33.2h-1.066c-34.849 0-63.2 28.352-63.2 63.2S205.086 271 239.934 271h32.134c18.306 0 33.199 14.894 33.199 33.2 0 18.306-14.893 33.2-33.199 33.2h-64.267c-8.284 0-15 6.716-15 15s6.716 15 15 15H241v33.201c0 8.284 6.716 15 15 15s15-6.716 15-15V367.4h1.067c34.848 0 63.199-28.352 63.199-63.2S306.915 241 272.067 241z"}})])
          )
        }
      }
    